export const MAX_COLUMNS_IN_ROW = 4;
